import { render, staticRenderFns } from "./AssistantNav.vue?vue&type=template&id=5fb4611c&"
import script from "./AssistantNav.vue?vue&type=script&lang=js&"
export * from "./AssistantNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports